import TkHelpIcon from "../../components/atoms/TkHelpIcon";

const stepperData = ["施設情報・職員情報", "届出内容確認", "機構へ提出"];
const tableHeadList = [
  {
    headTitle: (
      <>
        行移動
        <TkHelpIcon helpMessage={<>矢印で表示順序を変更可能です。</>} />
      </>
    ),
  },
  {
    headTitle: <>施設番号:施設名称</>,
  },
  {
    headTitle: <>施設種類</>,
  },
  {
    headTitle: <>申込時職員総数</>,
  },
  {
    headTitle: <>加入職員数</>,
  },
  {
    headTitle: <>雇用契約上の雇用期間1年未満職員数</>,
  },
  {
    headTitle: <>雇用契約上の労働時間２/３未満職員数</>,
  },
  {
    headTitle: <>職員情報登録状況</>,
  },
  {
    headTitle: <>施設情報の修正</>,
  },
  {
    headTitle: <>職員情報登録</>,
  },
];

export { stepperData, tableHeadList };
